export class PersonEntityModel {
    personID:string = "";
    NPN:string = "";
    altaUID:string = "";
    address1:string = "";
    address2:string = "";
    city:string = "";
    state:string = "";
    county:string = "";
    zip:string = "";
    email:string = "";
    phone:string = "";
    mobile:string = "";
    active:boolean = false;
    notes:string = "";
    title:string = "";
    firstName:string = "";
    middleName:string = "";
    lastName:string = "";
    dispName:string = "";
    picture:string = "";
    internal:boolean = false;
    doNotCall:boolean = false;    
}